import { useState } from 'react';
import { createPortal } from 'react-dom';
import Input from '../../../../../../components/Input/Input';
import { Button } from '../../../../../../components';
import FormLayout from '../../../../layout/FormLayout/FormLayout';

const NotesCreateForm = ({ selectedData, countries, onSave, onClose, disabled }: any) => {
    const [items, setItems] = useState<any[]>(selectedData);

    const handleInputChange = (prop: string) => (event: any) => {
        setItems(event.target.value);
    };

    return (
        <>
            {createPortal(
                <FormLayout
                    title={'Notes and comments'}
                    description={'Your notes and comments for the structure.'}
                    isAbsolute={true}
                    footerMain={!disabled && <Button onClick={onSave('notes', items)}>Upload</Button>}
                    onClose={onClose}
                >
                    <Input
                        type={'textarea'}
                        style={'text'}
                        rows={10}
                        max={5000}
                        name={'notes'}
                        value={items}
                        onChange={handleInputChange('notes')}
                        disabled={disabled}
                    />
                </FormLayout>,
                document && document.getElementById('formWrapper')!,
            )}
        </>
    );
};

export default NotesCreateForm;
